import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {useSelector} from 'react-redux'
import {http} from 'hiya-common/src/utils/axios'
import {cloneDeep, isEqual} from 'lodash'
import {
  IChannelItem,
  IOfficeChannelItem,
  IProductsReq,
  IProductsResp,
  IProfileResp,
  IThirdPartyItem,
  IWebThirdPartyItem,
} from '../reducers'
import {formatProduct} from '../utils'
import {ICouponSt, IUserCouponsReq, IUserCouponsResp} from '../service'

export const get_products_list_v2 = createAsyncThunk(
  '/live/pay/get_products_list_v2',
  async (productsReq: IProductsReq, store: any) => {
    const resp = await http.post<{data: IProductsResp}>(
      `/live/pay/get_products_list_v2`,
      {
        ...store.getState().env.deviceinfo,
        ...productsReq,
      }
    )

    return resp.data.data
  }
)

export const query_order_h5 = createAsyncThunk(
  '/live/pay/query_order_h5',
  async (params: {order_id: string}, store: any) => {
    const resp = await http.post<{data: any}>(
      `/live/pay/query_order_h5`,
      {
        ...store.getState().env.deviceinfo,
        ...params,
      },
      {
        xcErrorToast: true,
      }
    )

    return resp.data.data
  }
)

export const getProfile = createAsyncThunk(
  '/live/account/profile',
  async (params, store: any) => {
    const resp = await http.post<{data: IProfileResp}>(
      '/live/account/profile',
      {
        ...store.getState().env.deviceinfo,
      }
    )

    return resp.data.data
  }
)
/** 获取优惠卡券信息 */
export const getUserCoupons = createAsyncThunk(
  '/live/pay/get_user_coupons',
  async (params: IUserCouponsReq, store: any) => {
    const resp = await http.post<{data: IUserCouponsResp}>(
      '/live/pay/get_user_coupons',
      {
        ...store.getState().env.deviceinfo,
        name: 'Weekly recharge',
        limit: 100,
        ...params,
      }
    )
    return resp.data.data
  }
)

const initialState: {
  curPage: string
  curProduct: IThirdPartyItem & IWebThirdPartyItem
  curChannel: IChannelItem & IOfficeChannelItem & {tag: string}
  productList: (IThirdPartyItem & IWebThirdPartyItem)[]
  productListResp: IProductsResp
  account: IProfileResp
  isProductListFetched: boolean
  couponList: ICouponSt[]
} = {
  curPage: 'wallet',
  curProduct: {} as IThirdPartyItem & IWebThirdPartyItem,
  curChannel: {} as IChannelItem & IOfficeChannelItem & {tag: string},
  productList: [],
  productListResp: {
    list: [],
    coins: 0,
    coins_display: 0,
    is_recharged: false,
    third_party_list: [],
    countries: [],
    ra_score: 0,
    country_select_white: false,
    default_country: {
      code: undefined,
      name: '',
    },
    huawei_list: [],
    is_first_recharge: false,
    extra_desc_url: '',
    is_audit_ver: false,
    show_feedback_popup: false,
    desc: '',
    can_show_agency_list: false,
    order_exp: false,
    need_info_channel: [],
    pay_page_exp_type: 0,
    abt: '',
    third_party_list_v3: [],
    show_coupon: false,
  },
  isProductListFetched: false,
  account: {
    is_recharge_agency: false,
    is_coin_public: false,
    trade_remark: '',
    agency_coins: 0,
    agency_coins_display: 0,
    whats_app_infos: [],
  },
  couponList: [],
}

export const WalletAdvancedQuickSlice = createSlice({
  name: 'WalletAdvancedQuick',
  initialState,
  reducers: {
    setCurPage: (state, action) => {
      Object.assign(state, {curPage: action.payload})
    },
    setCurProduct: (state, action) => {
      Object.assign(state, {curProduct: action.payload})
    },
    setCurChannel: (state, action) => {
      Object.assign(state, {curChannel: action.payload})
    },
  },
  extraReducers: (builder) => {
    // builder.addCase(inviteInfo.fulfilled, (state, action) => {
    //   const {data = {}} = action.payload
    //   Object.assign(state.invite_info, data)
    // })
    builder.addCase(get_products_list_v2.fulfilled, (state, action) => {
      const resp = action.payload
      const {
        list,
        coins,
        coins_display,
        is_recharged,
        third_party_list,
        countries,
        default_country,
        huawei_list,
        is_first_recharge,
        extra_desc_url,
        is_audit_ver,
        show_feedback_popup,
        desc,
        can_show_agency_list,
        order_exp,
        need_info_channel,
        pay_page_exp_type,
        abt,
        third_party_list_v3,
        show_coupon,
        ra_score,
        country_select_white,
        ra_trade_info,
      } = resp

      Object.assign(state, {
        productListResp: {
          list,
          coins,
          coins_display,
          is_recharged,
          third_party_list: third_party_list || [],
          countries: countries || [],
          default_country: default_country || {},
          huawei_list,
          is_first_recharge,
          extra_desc_url,
          is_audit_ver,
          show_feedback_popup,
          desc,
          can_show_agency_list,
          order_exp,
          need_info_channel,
          pay_page_exp_type,
          abt,
          third_party_list_v3: third_party_list_v3 || [],
          show_coupon,
          ra_score,
          country_select_white,
          ra_trade_info,
        },
        isProductListFetched: true,
      })
      const formatList = cloneDeep(formatProduct(resp))
      if (!isEqual(formatList, state.productList)) {
        Object.assign(state, {productList: formatList})
      }
      // Object.assign(state, {productList: formatList})
    })

    builder.addCase(getProfile.fulfilled, (state, action) => {
      const res = action.payload
      Object.assign(state.account, {
        ...res,
      })
    })

    builder.addCase(getUserCoupons.fulfilled, (state, action) => {
      const {coupon_list} = action.payload
      Object.assign(state, {
        couponList: coupon_list,
      })
    })
  },
})

export default WalletAdvancedQuickSlice.reducer

export const WalletAdvancedQuickActions = WalletAdvancedQuickSlice.actions
export const useWalletAdvancedQuickState = () => {
  const data = useSelector((state) => {
    return state.WalletAdvancedQuick
  })
  return data
}
